/**
 * Invoice list thresholds.
 *
 * Single source of truth on the frontend for the pending-review
 * "Action Needed / Future Orders" split. MUST stay in lockstep with the
 * backend mirror INVOICE_NEED_DATE_WARNING_DAYS in
 * backend/feedmill_project/settings.py. Nothing may hardcode this number
 * anywhere else — import it.
 */

// Days before the customer NEED date (order.delivery_date) at which a
// pending-review invoice moves from "Future Orders" to "Action Needed".
export const INVOICE_NEED_DATE_WARNING_DAYS = 14;
